import React from 'react'
import styled from '@emotion/styled'

import { fontSizeSmall, fontSizeXSmall, fontSize3XSmall, fontSize2XSmall, fontWeightBold, fontWeightRegular, grayLight20, grayLight30, fontFamilyOpenSans } from '../../constants/principles'
import { useStateValue } from '../../hooks'
import { BrowserUtils } from '../../utils/siteUtils'
import { FlexDiv } from '../generic/Basics'
import ConditionPage from './ConditionPage'
import IconSvgs from './IconSvgs'
import PaintMeter from './PaintMeter'

export default ({ experienceState, qxData, prospectDocuments, globalState, nextClick, ...props }) => {
  const [localValueComment, setLocalValueComment] = useStateValue(props.urlState.dealerComment || (props.offer && props.offer.prospect && props.offer.prospect.dealerComment))
  const isDesktop = BrowserUtils.isDesktop()
  const isAdmin = experienceState.isAdmin
  const questionIdComment = 'qx/UserComments'
  const svgIcons = ['Engine', 'Transmission', 'Steering', 'Exhaust', 'Suspension', 'Heating/ Air Conditioning', 'Battery/ Electrical', 'Stereo', 'Odometer', 'Sunroof/ Moonroof', 'Airbags', 'Frame/ Structural']
  const conditionQuestions = prospectDocuments.documents && prospectDocuments.documents.find(document => document.id.split('/')[0] === 'qc').items.filter(item => item.section === 'Vehicle Condition')
  const title = conditionQuestions && conditionQuestions[0] ? conditionQuestions[0].section : 'n/a'

  const showPainMeter = false

  return (
    <>
      <ConditionPage
        {...{
          title,
          conditionQuestions,
          experienceState,
          globalState,
          nextClick: e => {
            // HACK: This guarantees that the two events don't fight each other. Not sure how else to fix this without changing the user experience.
            // Changing the state on blur was getting overridden by the click event.
            props.urlState.dealerComment = localValueComment
            nextClick(e)
          },
          ...props
        }}
        pageName={'mechanical'}
        svgIcons={[...svgIcons, 'Frame & Structural']}
        noDamage={'No mechanical issues or structural damage? Select Next'}>
        <SpacedDiv>
          <StyledH1 isDesktop={isDesktop}>{'Mechanical Issues'}</StyledH1>
          <StyledH2>{'Don’t worry if you’re not a mechanic. Just answer these questions the best you can. At the dealership, they’ll use the same questions to inspect your car – and share their results with you.'}</StyledH2>
          <IconSvgs titleOverride={'I have mechanical issues with...'} {...{ svgIcons, conditionQuestions, ...props }} />
        </SpacedDiv>
        {isAdmin && showPainMeter && (
          <>
            <SpacedDiv>
              <StyledH1>Paint Meter Readings</StyledH1>
              <StyledH2>Do you have paint meter readings?</StyledH2>
              <PaintMeter
                isDesktop={isDesktop}
                setShowModal={props.setShowModal}
                showModal={globalState.showModal}
                bodyStyle={props.bodyStyle}
                paintMeterQuestions={prospectDocuments.documents && prospectDocuments.documents.find(document => document.id.split('/')[0] === 'qmeter')}
                saveQuestionResponseArray={props.saveQuestionResponseArray}
                getQuestionResponseArray={props.getQuestionResponseArray}
              />
            </SpacedDiv>

            <SpacedDiv>
              <StyledH1>Additional Comments</StyledH1>
              <StyledH2>Please give us any additional information that might help us better evaluate this vehicle.</StyledH2>
              <StyleLabel htmlFor={questionIdComment}></StyleLabel>
              <StyledSpan>max 1000 characters</StyledSpan>
              <StyledTextArea name={questionIdComment} value={localValueComment} placeholder={'Comments'} rows={5} cols={40} maxLength={1000} onChange={e => setLocalValueComment(e.target.value)} />
            </SpacedDiv>
          </>
        )}
      </ConditionPage>
    </>
  )
}

const StyledH1 = styled.h1`
  font-size: ${p => (p.isDesktop ? fontSizeSmall : fontSizeXSmall)};
  font-weight: ${fontWeightBold};
  margin-top: 0px;
  margin-bottom: 0px;
`
const StyledH2 = styled.h2`
  font-size: ${fontSize2XSmall};
  font-weight: ${fontWeightRegular};
  margin: 12px 0;
  width: 100%;
`
const SpacedDiv = styled(FlexDiv)`
  padding-bottom: 40px;
  margin-bottom: 40px;
  border-bottom: 1px solid ${grayLight30};
  &:last-child {
    margin-bottom: 0px;
    padding-bottom: 0px;
    border-style: none;
  }
`
const StyledTextArea = styled.textarea`
  font-family: ${fontFamilyOpenSans};
  width: 80%;
  margin-bottom: 24px;
`
const StyleLabel = styled.label`
  font-size: ${fontSize3XSmall};
  color: ${grayLight20};
  text-align: left;
`
const StyledSpan = styled.span`
  font-size: ${fontSize3XSmall};
  color: ${grayLight20};
  text-align: left;
  width: 80%;
`
